import axios from "axios";



// import qs from "qs";

// axios.defaults.baseURL = "http://localhost:20020"; // 本地请求地址
axios.defaults.baseURL = "http://oa2.sunutech.net:8081"; // 服务器请求地址
axios.defaults.timeout = 5000; // /请求超时

axios.interceptors.request.use(
    (config) => {
        // console.log(111,config)
        return config;
    },
    (error) => {
        return Promise.reject(error);
    }
);

// 响应拦截器
axios.interceptors.response.use(
    (response) => {
        // store.isLoading = fasle;
        return response;
    },
    (err) => {
        return Promise.reject(err);
    }
);

// 封装通用的get请求和post请求
export default {
    get(url, data = {}) {
        return new Promise((resolve, reject) => {
            axios
                .get(url, {
                    params: data,
                })
                .then((response) => {
                    resolve(response.data);
                })
                .catch((err) => {
                    reject(err);
                });
        });
    },
    post(url, data = {}) {
        return new Promise((resolve, reject) => {
            axios
            // .post(url, qs.stringify(data))
                .post(url, data)
                .then((response) => {
                    resolve(response.data);
                })
                .catch((err) => {
                    reject(err);
                });
        });
    },
    put(url, data = {}) {
        return new Promise((resolve, reject) => {
            axios
                .put(url, data)
                .then((response) => {
                    resolve(response.data);
                })
                .catch((err) => {
                    reject(err);
                });
        });
    },
};